exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3zOZf{position:relative;margin-right:15px;margin-bottom:10px;font-size:14px;text-align:left}._1DJS_{margin-right:0}._1DJS_ label{padding-bottom:0;font-weight:400;padding-top:5px}._3zOZf .Select-control{height:36px;border-radius:3px;right:auto}._3zOZf .Select-input>input{width:100%!important}._3zOZf .Select--single>.Select-control .Select-value{max-width:96%}.yuNV7{text-transform:uppercase;color:#697586;padding-bottom:7px}._3OJNm,.yuNV7{display:block;font-size:13px}._3OJNm{color:#d7433d;font-weight:400;text-align:center;position:absolute;line-height:1.2;bottom:-20px}.MeWpF{position:relative;top:5px}._3UoY- .Select-control{border-color:#d7433d}.PCW7b{color:#d7433d;font-size:12px}", ""]);

// exports
exports.locals = {
	"root": "_3zOZf",
	"rootMobile": "_1DJS_",
	"title": "yuNV7",
	"errorMessage": "_3OJNm",
	"errorMessageMobile": "MeWpF",
	"isInvalid": "_3UoY-",
	"requiredField": "PCW7b"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/shared/components/insurance/components/FormSelect/FormSelect.css
// module id = 1906
// module chunks = 33 39 41 42 43